/**
 * Off-site destinations, kept in one place so the nav, CTAs and footer can't
 * drift apart when a URL changes.
 */
export const SIGN_IN_URL = 'https://app.meetsynthia.ai/'

/** Every "Book a demo" affordance, wherever it appears, opens the scheduler. */
export const DEMO_URL = 'https://calendly.com/demo-meetsynthia'

/**
 * Where the contact form POSTs. A browser cannot send mail on its own, so this
 * has to be a service that accepts the submission and forwards it — Formspree,
 * Basin, Web3Forms, a HubSpot form, or your own handler.
 *
 * Paste the endpoint URL here, e.g.
 *   'https://formspree.io/f/xxxxxxxx'
 *
 * While it is empty the form falls back to opening the visitor's mail client,
 * which is the old behaviour and requires them to press send themselves.
 */
export const FORM_ENDPOINT = 'https://formspree.io/f/mbgljqkk'

/** Inbox the submission is addressed to (and the fallback mailto target). */
export const CONTACT_EMAIL = 'hello@meetsynthia.ai'
